import type { SxProps, Theme } from '@mui/material'
import { Drawer } from '@mui/material'
import { styled } from '@mui/material/styles'

const CLOSED_DRAWER_WIDTH: number = 80 as const
const OPEN_DRAWER_WIDTH: number = 280 as const

// Trim the 64px app bar from MUI's height: 100% so the paper doesn't overflow with a native scrollbar.
export const drawerPaperSx = {
  backgroundColor: 'background.paper',
  top: '64px !important',
  height: 'calc(100% - 64px)',
  overflowY: 'hidden',
} satisfies SxProps<Theme>

export const StyledDrawer = styled(Drawer)(({ open, theme }) => {
  return `
    & .MuiPaper-root {
      width: ${open ? OPEN_DRAWER_WIDTH : CLOSED_DRAWER_WIDTH}px;
      overflow-x: ${open ? 'hidden' : 'visible'};
      transition: ${theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest,
      })};
    }
  `
}) as typeof Drawer
